// extracted by mini-css-extract-plugin
export default {"reactAdmin":"react-admin--nyALPXc7","content":"content--WPXSXDPc","page":"page--NecKxusC","empty":"empty--JlhkZ86E"};